const Seo = {
    defaultTitleSeo: 'InstaSorteio - Sorteio com comentários do Instagram',
    defaultDescriptionSeo: 'Realize sorteios a partir dos comentários do Instagram. A única que consegue carregar todos os comentários.',
    defaultKeywordsSeo: 'sorteios, sorteio, instagram, realizar, insta',
    defaultImageSeo: 'https://instasorteio.com/images/seo/metatag.png',
  };
  
  export default Seo;
  